import React from 'react';
import ReactDOM from 'react-dom';
import AuthorizedApp from './containers/AuthorizedApp.js';
import { Provider } from 'react-redux'
import './index.css';
import { firebase } from './firebase.js';
import store from './store.js';


const playlistRef = firebase.database().ref('playlist');
playlistRef.on('value', function(snapshot) {
  store.dispatch({
    type: 'UPDATE_PLAYLIST',
    playlist: snapshot.val()
  })
});


ReactDOM.render(
  <Provider store={store}>
    <AuthorizedApp />
  </Provider>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js